import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import ReadOnly, { ReadView } from '../../../../common/ReadOnly';
import { commaSeperator } from '../../../../utils/validation';

const KeyFundMetrics: React.FC = () => {
    const fundMetrics = useSelector((state: RootState) => state.deal.deal?.deal.fundDetails?.info?.fundMetrics);

    const list: ReadView[] = [
        {
            title: 'Key Fund Metrics',
            data: [
                {
                    key: 'Amount Disbursed Since Inception',
                    value: `${
                        fundMetrics?.amountDisbursedInMillions?.currency
                            ? `${fundMetrics.amountDisbursedInMillions.currency} ${commaSeperator(
                                  parseFloat(String(fundMetrics.amountDisbursedInMillions.amountUpto2dp || 0)).toFixed(
                                      2,
                                  ),
                              )}`
                            : ''
                    }`,
                },
                {
                    key: 'Number of Outstanding Loans',
                    value: fundMetrics?.outstandingLoanCount,
                },
                {
                    key: 'Annualized Net Return',
                    value: fundMetrics?.annualNetReturnInPercent ? `${fundMetrics.annualNetReturnInPercent}%` : '',
                },
                {
                    key: 'Weighted Average Maturity of the Portfolio',
                    value: fundMetrics?.weightedAvgMaturityInMonths
                        ? `${fundMetrics.weightedAvgMaturityInMonths} Months`
                        : '',
                },
                {
                    key: 'Average Loan Size of the Portfolio',
                    value: fundMetrics?.avgLoanSize?.currency
                        ? `${fundMetrics.avgLoanSize.currency} ${commaSeperator(
                              parseFloat(String(fundMetrics.avgLoanSize.amountUpto2dp || 0)).toFixed(2),
                          )}`
                        : '',
                },
                {
                    key: 'Net NAV Growth Over the Last Month',
                    value: fundMetrics?.lastMonthNAVGrowthInPercent
                        ? `${fundMetrics.lastMonthNAVGrowthInPercent}%`
                        : '',
                },
            ],
        },
    ];
    return (
        <div className="pb-4">
            <ReadOnly list={list} />
            {fundMetrics?.effectiveDate?.date && (
                <span className="text-xs">As of {fundMetrics.effectiveDate.date}</span>
            )}
        </div>
    );
};

export default KeyFundMetrics;
